import * as yup from 'yup';

export const PersonalDataSchema = yup.object({
  placeOfBirth: yup.string().notRequired().nullable(),
  dateOfBirth: yup.string().notRequired().nullable(),
  confession: yup.string().notRequired().nullable(),
  nationality: yup.string().notRequired().nullable(),
  maritalStatus: yup.string().notRequired().nullable(),
  numberOfChildren: yup.number().notRequired().nullable(),
});

export interface IPersonalData {
  placeOfBirth?: string;
  dateOfBirth?: string;
  confession?: string;
  nationality?: string;
  maritalStatus?: string;
  numberOfChildren?: number;
}
export const UpdatePersonalDataSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(PersonalDataSchema);

export interface IUpdatePersonalData {
  id: string;
}
